import { suggestedPrompts } from "app/modules/aiAssistant/conversation/messages/emptyChatContent";
import "./SuggestedPrompts.scss";

type Props = {
  onSelect: (promptText: string) => void;
  getTestId: (promptID: string) => string;
};

const SuggestedPrompts = ({ onSelect, getTestId }: Props) => (
  <div className="assistimo-suggested-prompts">
    {suggestedPrompts.map((prompt) => (
      <button
        key={prompt.id}
        data-test-id={getTestId(prompt.id)}
        type="button"
        className="assistimo-suggested-prompts__prompt"
        onClick={() => onSelect(prompt.text)}
      >
        {prompt.text}
      </button>
    ))}
  </div>
);

export default SuggestedPrompts;
